var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59495 14.614C1.78311 13.8299 1.13556 12.8919 0.690088 11.8549C0.244611 10.8179 0.0101284 9.70248 0.000320932 8.57386C-0.00948651 7.44524 0.205578 6.32596 0.632966 5.28134C1.06035 4.23672 1.6915 3.28768 2.48959 2.48959C3.28768 1.6915 4.23672 1.06035 5.28134 0.632966C6.32596 0.205578 7.44524 -0.00948651 8.57386 0.000320932C9.70248 0.0101284 10.8179 0.244611 11.8549 0.690088C12.8919 1.13556 13.8299 1.78311 14.614 2.59495C16.1623 4.19807 17.019 6.34519 16.9997 8.57386C16.9803 10.8025 16.0864 12.9344 14.5104 14.5104C12.9344 16.0864 10.8025 16.9803 8.57386 16.9997C6.34519 17.019 4.19807 16.1623 2.59495 14.614ZM9.79445 8.60445L12.1999 6.19895L11.0014 5.00045L8.60445 7.40595L6.19895 5.00045L5.00045 6.19895L7.40595 8.60445L5.00045 11.0099L6.19895 12.2084L8.60445 9.80295L11.0099 12.2084L12.2084 11.0099L9.80295 8.60445H9.79445Z",
    fill: "#23A863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).5c10bae9186fb8b1d49a59a7c53ccedf.svg";
export { ForwardRef as ReactComponent };